module.exports = __webpack_public_path__ + "img/img0502.24e8d7e3.png";